module.exports = __webpack_public_path__ + "f54adbc9a98c02e5fd36263af27aa36a.png";